export default __webpack_public_path__ + "static/media/logo-info-mini.8b870a9e.svg";